import React, { useEffect, useState } from 'react'
import { api } from '../../services'
import { Card, Spin, Icon, Typography, Row, Col, Tag, Button, message } from 'antd'
import history from '../../history'
import './quest.scss'
import LocationPickerModal from './components/LocationPickerModal'

const { Title, Text, Paragraph } = Typography

const ViewQuestStop = () => {
    const [locationData, setLocationData] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [isLocationModalVisible, setIsLocationModalVisible] = useState(false)
    const [isUpdating, setIsUpdating] = useState(false)

    const searchParams = new URLSearchParams(window.location.search)
    const location_id = searchParams.get('location_id')
    const stop_index = searchParams.get('stop_index')

    useEffect(() => {
        if (location_id) {
            getSpecificLocation(location_id)
        } else {
            setIsLoading(false)
        }
    }, [location_id])

    const getSpecificLocation = async (id) => {
        try {
            setIsLoading(true)
            const res = await api.quest.getSpecificLocation(id)
            if (res && res.data) {
                setLocationData(res.data)
            }
        } catch (error) {
            console.error('Error fetching location:', error)
        } finally {
            setIsLoading(false)
        }
    }

    const handleLocationSelect = async (selectedLocation) => {
        try {
            setIsUpdating(true)
            const payload = {
                stops: [
                    {
                        stop_number: parseInt(stop_index),
                        coordinates: `${selectedLocation.lat}, ${selectedLocation.lng}`,
                        name: selectedLocation.town || selectedLocation.full,
                        address: selectedLocation.full,
                    }
                ]
            }
            const res = await api.quest.updateSpecificLocation(location_id, payload)
            if (res && res.data) {
                message.success('Location updated successfully')
                // Re-fetch to update UI
                const updatedRes = await api.quest.getSpecificLocation(location_id)
                if (updatedRes && updatedRes.data) {
                    setLocationData(updatedRes.data)
                }
            }
        } catch (error) {
            console.error('Error updating location:', error)
            message.error('Failed to update location')
        } finally {
            setIsUpdating(false)
            setIsLocationModalVisible(false)
        }
    }

    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f5f7fa' }}>
                <Spin size="large" tip="Loading Quest Stop..." />
            </div>
        )
    }

    if (!locationData) {
        return (
            <div style={{ padding: '50px', textAlign: 'center' }}>
                <Icon type="frown" style={{ fontSize: 64, color: '#bfbfbf', marginBottom: 20 }} />
                <Title level={3}>Location Not Found</Title>
                <Button type="primary" onClick={() => history.goBack()}>Go Back</Button>
            </div>
        )
    }

    const { stops } = locationData
    const currentStop = stops && stop_index ? stops.find(s => s.stop_number === parseInt(stop_index)) : null

    if (!currentStop) {
        return (
            <div style={{ padding: '50px', textAlign: 'center' }}>
                <Icon type="warning" style={{ fontSize: 64, color: '#faad14', marginBottom: 20 }} />
                <Title level={3}>Treasure Hunt Stop {stop_index} Not Found</Title>
                <Button type="primary" onClick={() => history.goBack()}>Go Back</Button>
            </div>
        )
    }

    return (
        <div className="view-quest-stop-container" style={{ padding: '24px', background: '#f5f7fa', minHeight: '100vh' }}>
            <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
                    <Button
                        icon="left"
                        onClick={() => history.goBack()}
                        style={{ borderRadius: '20px', border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
                    >
                        Back
                    </Button>
                    <div>
                        <Tag color="#1890ff" style={{ fontSize: '14px', padding: '4px 12px', borderRadius: '4px' }}>
                            Treasure Hunt Stop #{currentStop.stop_number}
                        </Tag>
                        <Tag color="gold" style={{ fontSize: '14px', padding: '4px 12px', borderRadius: '4px' }}>
                            {currentStop.points || 0} PTS
                        </Tag>
                    </div>
                </div>

                <div className="accordion__item" style={{ opacity: 1, padding: 0 }}>
                    <div className="accordion__header active" style={{ cursor: 'default' }}>
                        <div className="accordion__title" style={{ fontSize: '20px' }}>
                            {currentStop.title}
                        </div>
                    </div>

                    <div className="accordion__content corporate-style">
                        <div className="accordion__section">
                            <h4 className="corporate-label">Mission Narrative</h4>
                            <p className="corporate-text">{currentStop.story}</p>
                        </div>

                        <div className="accordion__grid">
                            <div className="accordion__section">
                                <h4 className="corporate-label">Fun Fact</h4>
                                <div className="corporate-insight">
                                    <Icon type="bulb" style={{ color: '#faad14', marginRight: 8 }} />
                                    {currentStop.fun_fact}
                                </div>
                            </div>
                            <div className="accordion__section">
                                <h4 className="corporate-label">Open Ended Question</h4>
                                <p className="corporate-text-secondary">{currentStop.quiz?.open_ended}</p>
                            </div>
                        </div>

                        <div className="accordion__grid">
                            <div className="accordion__section">
                                <h4 className="corporate-label">Knowledge Check</h4>
                                <div className="quiz-box">
                                    <div className="quiz-question">
                                        <Icon type="question-circle" style={{ color: '#1890ff', marginRight: 8 }} />
                                        {currentStop.quiz?.multiple_choice?.question}
                                    </div>
                                    <ul className="quiz-options">
                                        {currentStop.quiz?.multiple_choice?.options?.map((opt, i) => (
                                            <li key={i}>
                                                {opt}
                                            </li>
                                        ))}
                                        {/* {currentStop.quiz?.multiple_choice?.options?.map((opt, i) => (
                                            <li key={i} className={i === currentStop.quiz?.multiple_choice?.correct_index ? 'correct' : ''}>
                                                {i === currentStop.quiz?.multiple_choice?.correct_index && <Icon type="check-circle" theme="filled" />}
                                                {opt}
                                            </li>
                                        ))} */}
                                    </ul>
                                </div>
                            </div>
                            {currentStop.clue && (
                                <div className="accordion__section">
                                    <h4 className="corporate-label">Mission Hints</h4>
                                    <div className="corporate-insight" style={{ marginBottom: 12 }}>
                                        <div style={{ fontSize: '13px', color: '#595959' }}>{currentStop.clue.narrative_content}</div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="accordion__location_grid">
                            {(currentStop.location || currentStop.clue) && (
                                <div className="accordion__section">
                                    <h4 className="corporate-label">Location Hints</h4>
                                    {currentStop.location && (
                                        <div className="corporate-insight" style={{ marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <Icon type="environment" style={{ color: '#1890ff', marginRight: 8, marginTop: 4 }} />
                                                <div>
                                                    <strong>{currentStop.location.name}</strong>
                                                    <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{currentStop.location.address}</div>
                                                </div>
                                            </div>
                                            <Button
                                                type="link"
                                                size="small"
                                                icon="edit"
                                                loading={isUpdating}
                                                onClick={() => setIsLocationModalVisible(true)}
                                            >
                                                Edit
                                            </Button>
                                        </div>
                                    )}
                                    <div className="corporate-hints">
                                        {currentStop.clue?.mission_context && (
                                            <div className="hint-item">
                                                <span className="hint-label">Mission:</span>
                                                <span className="hint-value">{currentStop.clue.mission_context}</span>
                                            </div>
                                        )}
                                        {currentStop.clue?.location_clues && (
                                            <div className="hint-item" style={{ flexDirection: 'column' }}>
                                                <span className="hint-label" style={{ width: '100%', marginBottom: 8 }}>Clues:</span>
                                                <div className="tag-group" style={{ display: 'block', marginLeft: 0 }}>
                                                    {currentStop.clue.location_clues.map((c, i) => (
                                                        <div key={i} className="corporate-text-secondary" style={{ marginBottom: 4, background: 'rgba(255,255,255,0.5)' }}>• {c}</div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                        {currentStop.clue?.confirmation && (
                                            <div className="hint-item" style={{ marginTop: 8 }}>
                                                <span className="hint-label">Find:</span>
                                                <span className="hint-value" style={{ color: '#52c41a', fontWeight: 600 }}>{currentStop.clue.confirmation}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* <div style={{ padding: '40px 0', textAlign: 'center' }}>
                    ...
                </div> */}

                <LocationPickerModal
                    open={isLocationModalVisible}
                    onClose={() => setIsLocationModalVisible(false)}
                    onLocationSelect={handleLocationSelect}
                    value={currentStop.location ? {
                        lat: parseFloat(currentStop.location.coordinates?.split(',')[0]),
                        lng: parseFloat(currentStop.location.coordinates?.split(',')[1]),
                        full: currentStop.location.address
                    } : null}
                />
            </div>
        </div>
    )
}

export default ViewQuestStop

